export default "__VITE_ASSET__b0e9a41c__"